import {
  type CreatePolicyInput,
  CreateBackupPolicyApi,
  DeleteBackupPolicyApi,
  GetBackupPolicyApi,
  ListBackupPoliciesApi,
  type BackupPolicyConfig,
  type Condition,
  type Configuration,
  UpdateBackupPolicyApi,
} from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';

import { toJsonText } from '@/components/queryBuilder/QueryLanguageConverter';

import type { HttpClient } from './httpClient';

const basesUrl = '/backup-policies';

export const backupPolicy = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listBackupPoliciesApi = new ListBackupPoliciesApi(config);
  const getBackupPolicyApi = new GetBackupPolicyApi(config);
  const createBackupPolicyApi = new CreateBackupPolicyApi(config);
  const updateBackupPolicyApi = new UpdateBackupPolicyApi(config);
  const deleteBackupPolicyApi = new DeleteBackupPolicyApi(config);
  return {
    useList: (
      pageIndex?: number,
      pageSize?: number,
      filter?: Condition,
      options?: SWRConfiguration
    ) =>
      httpClient.executeWithConfig(
        listBackupPoliciesApi.listPolicies.bind(listBackupPoliciesApi),
        basesUrl,
        '',
        options,
        currentProjectId,
        pageIndex,
        pageSize ? pageSize : 2000,
        filter ? toJsonText(filter) : undefined
      ),
    useGet: (policyId: string | null) =>
      httpClient.execute(
        getBackupPolicyApi.getPolicy.bind(getBackupPolicyApi),
        policyId ? basesUrl : null,
        policyId ?? '',
        currentProjectId,
        policyId ?? ''
      ),
    create: (policy: CreatePolicyInput) =>
      createBackupPolicyApi.createPolicy(currentProjectId, policy),
    update: (policy: BackupPolicyConfig) =>
      updateBackupPolicyApi.updatePolicy(currentProjectId, policy.id, policy),
    delete: (policyId: string) =>
      deleteBackupPolicyApi.deletePolicy(currentProjectId, policyId),
  };
};
